import { createSlice } from '@reduxjs/toolkit';

// DOMAIN
import { Domain } from 'constant';

// MODEL
import { AACCheckInCheckOutState, CheckInCheckOutStep, VerificationRole } from 'model';

// REDUCER ACTION
import {
  changeCheckInCheckOutAacLoading,
  changeCheckInCheckOutAacNRIC,
  changeCheckInCheckOutAacSelectedEvent,
  changeCheckInCheckOutAacShowSomethingWentWrong,
  changeCheckInCheckOutAacValidateProfileError,
  changeCheckInCheckOutAacVerificationRole,
  setCheckInCheckOutStep,
  setAACCheckInCheckOutData,
  changeCheckInCheckOutAacVolunteerData,
  changeCheckInCheckOutAacVerificationType,
  changeCheckInCheckOutAacVerificationValue,
  changeCheckInCheckOutAacNumberOfVolunteers
} from './reducers';

export const initialState: AACCheckInCheckOutState = {
  loading: false,
  step: CheckInCheckOutStep.VALIDATION_PROFILE,
  volunteerData: undefined,
  checkInCheckOut: undefined,
  showSomethingWentWrong: false,
  validateProfileError: undefined,
  verificationRole: VerificationRole.PARTICIPANT,
  nric: '',
  selectedEvent: undefined,
  verificationType: undefined,
  verificationValue: undefined,
  numberOfVolunteers: undefined
};

export const checkInCheckOutCenterSlice = createSlice({
  name: Domain.CheckInCheckOutCenterAAC,
  initialState,
  reducers: {
    changeCheckInCheckOutAacLoading,
    changeCheckInCheckOutAacNRIC,
    changeCheckInCheckOutAacSelectedEvent,
    setAACCheckInCheckOutData,
    setCheckInCheckOutStep,
    changeCheckInCheckOutAacShowSomethingWentWrong,
    changeCheckInCheckOutAacValidateProfileError,
    changeCheckInCheckOutAacVerificationRole,
    changeCheckInCheckOutAacVolunteerData,
    changeCheckInCheckOutAacVerificationType,
    changeCheckInCheckOutAacVerificationValue,
    changeCheckInCheckOutAacNumberOfVolunteers
  }
});

export default checkInCheckOutCenterSlice.reducer;
